import { render, staticRenderFns } from "./QLSChildCustom.vue?vue&type=template&id=22be9371&scoped=true&"
import script from "./QLSChildCustom.vue?vue&type=script&lang=ts&"
export * from "./QLSChildCustom.vue?vue&type=script&lang=ts&"
import style0 from "./QLSChildCustom.vue?vue&type=style&index=0&id=22be9371&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be9371",
  null
  
)

export default component.exports